import { NotificationWithId } from '../../components/NotificationContainer'
import { IAppError } from '../../interfaces/base'

export type Type = {
  notifications: NotificationWithId[]
  error: IAppError | null
}

export const initial: Type = {
  notifications: [],
  error: null,
}
